import useStyles from '../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import React, { useState, useRef, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import EAIcon from '../../../../../components/common/EAIcon';
import EACustomColorPicker from '../../../../../components/attributes/EACustomColorPicker';

const ColorPickerField = ({ fieldName, defaultValue, disabled = false }) => {
  const { classes } = useStyles();

  const [pickerIsOpen, setPickerIsOpen] = useState(false);
  const [pickerValue, setPickerValue] = useState(defaultValue);
  const pickerRef = useRef(null);
  const buttonRef = useRef(null);

  const formMethods = useFormContext();
  const { setValue } = formMethods;

  // Fermer le picker si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Vérifier si le clic est sur un élément MUI (menu, backdrop, etc.)
      const isMuiElement = event.target.closest(
        '.MuiPopover-root, .MuiModal-root, .MuiPaper-root'
      );

      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        !isMuiElement
      ) {
        setPickerIsOpen(false);
      }
    };

    pickerIsOpen && document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [pickerIsOpen]);

  return (
    <>
      {!disabled && pickerIsOpen && (
        <div
          ref={pickerRef}
          style={{ position: 'absolute', right: '-14px', top: '54px', zIndex: 200, }}
          onClick={(e) => e.stopPropagation()}
        >
          <EACustomColorPicker
            pickerValue={pickerValue}
            onChange={(color) => {
              setPickerValue(color.hex);
              setValue(`${fieldName}`, color.hex);
              setPickerIsOpen(!pickerIsOpen);
            }}
          />
        </div>
      )}
      <div
        ref={buttonRef}
        style={{ background: pickerValue === '' ? '#E2E2EA' : pickerValue, cursor: 'pointer', zIndex: 1, }}
        className={classes.colorPickerWrapper}
        onClick={(e) => {
          e.stopPropagation();
          setPickerIsOpen(!pickerIsOpen);
        }}
      >
        {pickerValue === '' && (
          <EAIcon icon={'colorDot'} style={{ position: 'absolute', top: '-7px', left: '-7px', bottom: '7px', right: '7px', }} />
        )}
        <div className={classes.colorPickerPenIcon}>
          <EAIcon icon={'edit_dark'} />
        </div>
      </div>
    </>
  );
};

export default ColorPickerField;